/**
 * 场景 Schema
 */
export default {
  properties: {
    // 地图容器 ID
  },
};
